import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserSearchHistoryService {

    constructor() { }

    getUserSearchHistory = (): any => JSON?.parse(localStorage?.getItem(environment?.appName + "SH"));


    setUserSearchHistory = (x): any => {
        if (!this.getUserSearchHistory()) {
            localStorage?.setItem(environment?.appName + "SH", JSON?.stringify([x]));
        } else {
            let searchArray = this.getUserSearchHistory();
            if (searchArray.includes(x)) {
                return
            } else {
                if (searchArray.length > 4) {
                    searchArray.pop();
                    searchArray.unshift(x)
                    localStorage?.setItem(environment?.appName + "SH", JSON?.stringify(searchArray));
                } else {
                    searchArray.unshift(x)
                    localStorage?.setItem(environment?.appName + "SH", JSON?.stringify(searchArray));
                }
            }
        }
    }

    removeUserSearchHistory = (index): any => {
        let searchArray = this.getUserSearchHistory();
        searchArray.splice(index, 1);
        localStorage?.setItem(environment?.appName + "SH", JSON?.stringify(searchArray));
    }


}
